import { FC, useContext } from 'react';
import styled from 'styled-components';

import LocalizedLink from '@/components/LocalizedLink/LocalizedLink';
import { translate } from '@/lib/translate';
import { GlobalContext } from '@/pages/_app';

const RelevantStory: FC<any> = ({ link, image, title }) => {
	const { lang } = useContext(GlobalContext);
	const imageTitle = translate(lang, {
		en: `Viber Success Stories ${title}`,
		ru: `Истории успеха Viber ${title}`,
		ua: `Історії успіху Viber ${title}`,
	});

	return (
		<StoryItem>
			<LocalizedLink href={`/success-stories/story/${link}`}>
				<img alt={imageTitle} src={image} />

				<span>{title}</span>
			</LocalizedLink>
		</StoryItem>
	);
};

const StoryItem = styled.div`
	width: 29.5%;

	@media (max-width: 900px) {
		width: 31%;
		max-width: 100%;
		margin-bottom: 20px;
	}

	@media (max-width: 600px) {
		width: 46%;
		margin-bottom: 25px;
	}

	@media (max-width: 440px) {
		width: 100%;
	}
	img {
		display: block;
		max-width: 100%;
		margin-bottom: 23px;
		border-radius: 20px;

		@media (max-width: 600px) {
			margin-bottom: 10px;
		}
	}

	a {
		text-decoration: none;
	}

	span {
		display: block;
		padding-left: 10px;
		font-family: var(--font-sans);

		font-size: 25px;
		line-height: 35px;
		color: var(--color-white);
	}

	@media (max-width: 900px) {
		span {
			font-size: 20px;
		}
	}
`;

export default RelevantStory;
